<template>
	<div class="alltitlStyle">
		<h2 class="modTitlte">
			<span>{{ titleObj.title }}</span>
		</h2>
		<p v-if="titleObj.p" v-html="titleObj.p"></p>
	</div>
</template>
<script>
export default {
	name: "TitleAssembly",
	props: {
		titleObj:{
      type:Object,
      default:{}
    }
	},
	components: {},
	data() {
		return {};
	},
	created() {},
	mounted() {},
	methods: {},
};
</script>
<style lang="scss" scoped>
.alltitlStyle{
 margin:30px;
 p{
   text-align:center;
 }
}
.modTitlte {
	font-size: 30px;
	text-align: center;
	margin: 56px 0 15px 0;
  z-index:99;
  span{
    display: inline-block;
    position: relative;
    z-index:100;
  }
}
.modTitlte span::after{
  content:'';
  width:100%;
  left:0;
  right:0;
  height:10px;
  border-radius: 10px;
  background:#dee9fe;
  position: absolute;
  display: inline-block;
  z-index:-1;
  bottom:3px;
}
</style>
